import { gql } from "@apollo/client";

export const CHAT_CONVERSATION_BASIC_FRAGMENT = gql`
  fragment ChatConversationBasic on IntentChatConversation {
    id
    description
    createdAt
    updatedAt
  }
`;

export const CHAT_CONVERSATION_MESSAGES_FRAGMENT = gql`
  fragment ChatConversationMessages on IntentChatConversation {
    id
    description
    version
    lastUsedAIIntegration {
      id
    }
    lastUsedAIModel
    messages {
      id
      content
    }
  }
`;
